import { useContext } from "react";
import { LocaleContext } from "../context/locale-context";

export default function useLocale() {
  const locale = useContext(LocaleContext);
  const isAra = locale === "ar";
  return { isAra, locale };
}
